import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { AssetTableComponent } from "./asset-table/asset-table.component";

import { AssetFormComponent } from "./asset-form/asset-form.component";
import { AuthGuardWithForcedLogin } from "../../shared/services/auth-guard-with-forced-login.service";
import { CanDeactivateGuard } from "../../shared/services/can-deactivate.guard";

const routes: Routes = [
  {
    path: "",
    component: AssetTableComponent,
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: "form",
    component: AssetFormComponent,
    canActivate: [AuthGuardWithForcedLogin],
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: "form/assetId",
    component: AssetFormComponent,
    canActivate: [AuthGuardWithForcedLogin],
    canDeactivate: [CanDeactivateGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AssetRoutingModule {}
